// Centralized config for the search bar category dropdown.
// Each entry knows which Typesense collection(s) to search and what
// main_category filter (if any) to apply.
//
// To add a new category option (e.g. Promotions, Reviewer profiles)
// just append a new entry here – no other files need updating.

export const SEARCH_CATEGORIES = [
  {
    value: 'Day-Time Activities',
    label: { TH: 'กิจกรรมกลางวัน', EN: 'Day-Time Activities', CN: '日间活动' },
    source: ['events'],
    categoryFilter: 'Day-Time Activities',
  },
  {
    value: 'Night-Time Activities',
    label: { TH: 'กิจกรรมกลางคืน', EN: 'Night-Time Activities', CN: '夜间活动' },
    source: ['events'],
    categoryFilter: 'Night-Time Activities',
  },
  {
    value: 'Small Group Activities',
    label: { TH: 'กิจกรรมกลุ่มเล็ก', EN: 'Small Group Activities', CN: '小组活动' },
    source: ['events'],
    categoryFilter: 'Small Group Activities',
  },
  {
    value: 'Review',
    label: { TH: 'รีวิว', EN: 'Review', CN: '评论' },
    source: ['reviews'],
    categoryFilter: null, // reviews collection has no main_category field
  },
  {
    value: 'Restaurants',
    label: { TH: 'ร้านอาหาร', EN: 'Restaurants', CN: '餐厅' },
    source: ['venues'],
    categoryFilter: null, // venues collection - no category filter for now (show all venues)
  },
];
